import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

// EDITORS
import CarouselEditor from './sections/CarouselEditor';
import AboutEditor from './sections/AboutEditor';
import CountdownEditor from './sections/CountdownEditor';
import CountersEditor from './sections/CountersEditor';
import ScheduleEditor from './sections/ScheduleEditor';
import ArtistsEditor from './sections/ArtistsEditor';
import GalleryEditor from './sections/GalleryEditor';
import TicketsEditor from './sections/TicketsEditor';
import ContactEditor from './sections/ContactEditor';
import BookingsAdmin from './sections/BookingsAdmin';
import ReportsEditor from './sections/ReportsEditor';

const TABS = [
  { key: 'carousel',  title: 'Hero / Carousel', icon: 'lni-image' },
  { key: 'about',     title: 'Über das Festival', icon: 'lni-information' },
  { key: 'countdown', title: 'Countdown', icon: 'lni-timer' },
  { key: 'counters',  title: 'Counter-Kacheln', icon: 'lni-dashboard' },
  { key: 'schedule',  title: 'Konzerte / Programm', icon: 'lni-calendar' },
  { key: 'artists',   title: 'Künstler*innen', icon: 'lni-users' },
  { key: 'gallery',   title: 'Galerie', icon: 'lni-gallery' },
  { key: 'tickets',   title: 'Tickets', icon: 'lni-ticket' },
  { key: 'contact',   title: 'Kontakt / Karte', icon: 'lni-map' },
  { key: 'bookings', title: 'Reservierungen', icon: 'lni-envelope' },
  { key: 'reports',  title: 'Berichte', icon: 'lni-files' },
];

export default function AdminHome() {
  const [active, setActive] = useState('carousel');
  const { user, logout } = useAuth0();

  const initials = (user?.name || user?.email || 'A')
    .split('@')[0]
    .split(' ')
    .map(s => s[0])
    .slice(0,2)
    .join('')
    .toUpperCase();

  return (
    <>
      {/* Header */}
      <div className="admin-header">
        <div className="container admin-header-grid">
          <div className="admin-brand">
            <h2 className="admin-title m-0">Komponistinnen Musikfestival • Admin</h2>
            <p className="admin-sub">Inhalte sicher und stilvoll verwalten</p>
          </div>

          <div className="admin-userbar">
            <div className="user-chip">
              <div className="user-chip__avatar">{initials}</div>
              <div className="user-chip__meta">
                <div className="user-chip__name">{user?.name || user?.email}</div>
                <div className="user-chip__status">Angemeldet</div>
              </div>
            </div>
            <button
              className="btn-logout"
              onClick={() =>
                logout({ logoutParams: { returnTo: window.location.origin } })
              }
              aria-label="Logout"
            >
              <i className="lni-exit"></i> <span className="d-none d-sm-inline">Logout</span>
            </button>
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="container admin-container mt-3">
        {/* Mobile-friendly, horizontally scrollable tabs */}
        <ul className="nav nav-tabs admin-tabs flex-wrap">
          {TABS.map((t) => (
            <li className="nav-item" key={t.key}>
              <button
                className={`nav-link d-inline-flex align-items-center gap-2 ${active === t.key ? 'active' : ''}`}
                onClick={() => setActive(t.key)}
              >
                <i className={t.icon} />
                <span className="tab-title-text">{t.title}</span>
              </button>
            </li>
          ))}
        </ul>

        <div className="editor-surface">
          {active === 'carousel'  && <CarouselEditor />}
          {active === 'about'     && <AboutEditor />}
          {active === 'countdown' && <CountdownEditor />}
          {active === 'counters'  && <CountersEditor />}
          {active === 'schedule'  && <ScheduleEditor />}
          {active === 'artists'   && <ArtistsEditor />}
          {active === 'gallery'   && <GalleryEditor />}
          {active === 'tickets'   && <TicketsEditor />}
          {active === 'contact'   && <ContactEditor />}
          {active === 'bookings' && <BookingsAdmin />}
          {active === 'reports'  && <ReportsEditor />}
        </div>
      </div>
    </>
  );
}
